import { Modal, Text } from '@bigcommerce/big-design';

const DeleteDialog = ({ showDeleteDialog, setShowDeleteDialog, removeSupplier, activeId }) => {

  return (
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowDeleteDialog(false),
        },
        { text: 'Delete Supplier', onClick: () => removeSupplier(activeId) },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Delete Supplier"
      isOpen={showDeleteDialog}
      onClose={() => setShowDeleteDialog(false)}
    >
      <Text>
        Are you sure you want to delete this supplier? All supplier assignments related to this supplier will also be deleted.
      </Text>
    </Modal>
  )
}

export default DeleteDialog;
